/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipReportExportStatusQueryResponse, AuditReportsGetGipReportExportStatusPathParams, AuditReportsGetGipReportExportStatus401, AuditReportsGetGipReportExportStatus403, AuditReportsGetGipReportExportStatus404 } from "../models/AuditReportsGetGipReportExportStatus";

export function getAuditReportsGetGipReportExportStatusUrl(id: AuditReportsGetGipReportExportStatusPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/report/${id}/export-status` as const }
  return res
}

/**
 * @summary Get export job status for report
 * {@link /audit-reports/v1/reports/gip/report/:id/export-status}
 */
export async function auditReportsGetGipReportExportStatus(id: AuditReportsGetGipReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipReportExportStatusQueryResponse, ResponseErrorConfig<AuditReportsGetGipReportExportStatus401 | AuditReportsGetGipReportExportStatus403 | AuditReportsGetGipReportExportStatus404>, unknown>({ method : "GET", url : getAuditReportsGetGipReportExportStatusUrl(id).url.toString(), ... requestConfig })
  return res.data
}